module.exports = __webpack_public_path__ + "img/animation.ad9541c9.svg";